import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function HeroStory({ stories = [] }) {
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        if (stories.length <= 1) return;
        const t = setInterval(
            () => setIdx((i) => (i + 1) % stories.length),
            7000,
        );
        return () => clearInterval(t);
    }, [stories.length]);

    if (!stories.length) {
        return (
            <div
                className="relative col-span-12 md:col-span-8 min-h-[60vh] bg-streetz-paper border border-streetz-line"
                data-testid="hero-empty-state"
            />
        );
    }

    const s = stories[idx];
    return (
        <div
            data-testid="hero-story"
            className="relative col-span-12 md:col-span-8 min-h-[60vh] md:min-h-[70vh] bg-streetz-paper border border-streetz-line overflow-hidden group"
        >
            <img
                src={s.image_url}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover opacity-90"
                onError={(e) => (e.currentTarget.style.display = "none")}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-6 md:p-12 max-w-3xl">
                <span
                    data-testid="hero-top-story-badge"
                    className="inline-flex w-fit bg-streetz-red text-white px-3 py-1 overline mb-4"
                >
                    TOP STORY
                </span>
                <h1
                    data-testid="hero-title"
                    className="font-display text-5xl sm:text-6xl lg:text-7xl xl:text-8xl uppercase tracking-tight leading-[0.95] text-white text-shadow-hero"
                >
                    {s.title}
                </h1>
                <p
                    data-testid="hero-excerpt"
                    className="mt-5 text-base md:text-lg text-white/85 max-w-2xl"
                >
                    {s.excerpt}
                </p>
                <Link
                    to={`/article/${s.slug}`}
                    data-testid="hero-read-story-cta"
                    className="mt-6 inline-flex items-center gap-3 bg-white text-black px-6 py-3 overline w-fit hover:bg-streetz-red hover:text-white transition-colors"
                >
                    READ STORY
                    <span className="w-8 h-8 grid place-items-center bg-streetz-red text-white">
                        <ArrowRight className="w-4 h-4" />
                    </span>
                </Link>

                {stories.length > 1 && (
                    <div className="mt-8 flex gap-2">
                        {stories.map((s, i) => (
                            <button
                                key={s.id || s.slug || i}
                                aria-label={`Slide ${i + 1}`}
                                data-testid={`hero-slide-dot-${i}`}
                                onClick={() => setIdx(i)}
                                className={`h-1 transition-all ${
                                    i === idx
                                        ? "w-12 bg-white"
                                        : "w-6 bg-white/40"
                                }`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
